// components/DisclaimerPage.jsx
import React from 'react';
import { theme } from '../theme';

export function DisclaimerPage({ onBack }) {
  return (
    <div style={{ minHeight: '100vh', background: theme.bg, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', color: theme.text }}>
      <nav style={{ maxWidth: '900px', margin: '0 auto', padding: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ fontFamily: 'Georgia, serif', fontSize: '32px', fontWeight: 400, color: theme.teal, margin: 0, cursor: 'pointer' }} onClick={onBack}>InsightStock</h1>
        <button onClick={onBack} style={{ background: 'transparent', border: '1px solid ' + theme.border, borderRadius: '8px', padding: '10px 20px', color: theme.text, fontSize: '16px', cursor: 'pointer' }}>← Back</button>
      </nav>

      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 24px 80px' }}>
        <h1 style={{ fontFamily: 'Georgia, serif', fontSize: '42px', fontWeight: 400, color: theme.text, margin: '0 0 16px' }}>Disclaimer</h1>
        <p style={{ color: theme.textDark, fontSize: '16px', margin: '0 0 48px' }}>Last updated: January 23, 2026</p>

        <Section title="Not Financial Advice">
          InsightStock is an AI-powered research tool designed to help investors organize and analyze publicly available market information. <strong>Nothing on this platform constitutes financial, investment, legal, or tax advice.</strong>
          {'\n\n'}We are not registered as a securities broker-dealer, investment advisor, or financial planner with the U.S. Securities and Exchange Commission (SEC), FINRA, or any state regulatory authority.
        </Section>

        <Section title="AI-Generated Content">
          Our platform uses artificial intelligence to analyze market data, news, and financial information. You should be aware that:
          {'\n\n'}• <strong>AI can make mistakes.</strong> Our analysis may contain errors, inaccuracies, or misinterpretations.
          {'\n'}• <strong>AI is not omniscient.</strong> Our models may not have access to all relevant information or the most recent data.
          {'\n'}• <strong>AI cannot predict the future.</strong> Past performance and current signals do not guarantee future results.
          {'\n'}• <strong>AI-generated summaries are not original reporting.</strong> Always verify important information with official sources such as SEC filings, company press releases, and reputable news outlets.
        </Section>

        <Section title="Investment Risks">
          Investing in securities involves substantial risk, including the possible loss of principal. Before making any investment decision, you should:
          {'\n\n'}• Conduct your own research and due diligence
          {'\n'}• Consult with a qualified financial advisor
          {'\n'}• Consider your personal financial situation, goals, and risk tolerance
          {'\n'}• Review official company filings (10-K, 10-Q, 8-K) on SEC EDGAR
          {'\n'}• Understand that market conditions can change rapidly
        </Section>

        <Section title="Data Sources">
          InsightStock aggregates data from third-party sources including Polygon.io and various news providers. We do not guarantee the accuracy, completeness, or timeliness of this data. Data may be delayed, incomplete, or contain errors from the original sources.
        </Section>

        <Section title="Portfolio Review Feature">
          Our Portfolio Review feature (Pro+) analyzes your uploaded trade history to provide insights about your trading patterns. This analysis:
          {'\n\n'}• Is based solely on the data you provide
          {'\n'}• Does not account for your complete financial picture
          {'\n'}• Should not be used as the sole basis for changing your investment strategy
          {'\n'}• Is for educational and informational purposes only
        </Section>

        <Section title="No Guarantees">
          We make no guarantees regarding:
          {'\n\n'}• The accuracy or reliability of any analysis or information
          {'\n'}• Future stock performance or market movements
          {'\n'}• The suitability of any information for your specific situation
          {'\n'}• Investment returns or protection against losses
        </Section>

        <Section title="Your Responsibility">
          By using InsightStock, you acknowledge that:
          {'\n\n'}• You are solely responsible for your own investment decisions
          {'\n'}• You will not hold Insight Mind AI LLC liable for any investment losses
          {'\n'}• You understand the risks associated with investing in securities
          {'\n'}• You will verify all information before making financial decisions
        </Section>

        <Section title="Limitation of Liability">
          Under no circumstances shall Insight Mind AI LLC, its officers, directors, employees, or affiliates be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from:
          {'\n\n'}• Your use of or inability to use the Service
          {'\n'}• Any errors or omissions in our content
          {'\n'}• Any investment decisions you make based on our information
          {'\n'}• Any unauthorized access to your account or data
        </Section>

        <Section title="Contact">
          If you have questions about this Disclaimer, contact us at:
          {'\n\n'}Insight Mind AI LLC
          {'\n'}1621 Central Ave
          {'\n'}Cheyenne, WY 82001
          {'\n'}Email: support@insightstock.io
        </Section>

        <div style={{ background: 'rgba(248, 81, 73, 0.1)', border: '1px solid rgba(248, 81, 73, 0.3)', borderRadius: '12px', padding: '24px', marginTop: '48px' }}>
          <p style={{ color: theme.red, fontSize: '18px', fontWeight: 600, margin: '0 0 12px' }}>⚠️ Important Reminder</p>
          <p style={{ color: theme.textMuted, fontSize: '17px', lineHeight: '1.7', margin: 0 }}>
            InsightStock is a research tool, not a financial advisor. Always do your own research and consult with qualified professionals before making investment decisions. Past performance is not indicative of future results.
          </p>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '36px' }}>
      <h2 style={{ fontFamily: 'Georgia, serif', fontSize: '22px', fontWeight: 400, color: theme.teal, margin: '0 0 16px' }}>{title}</h2>
      <p style={{ color: theme.textMuted, fontSize: '17px', lineHeight: '1.8', margin: 0, whiteSpace: 'pre-line' }}>{children}</p>
    </div>
  );
}

export default DisclaimerPage;